module.exports = __webpack_public_path__ + "static/media/28DGC10.66191d5e.jpg";